import React, { useEffect, useState } from "react";
import { CalendarRange, CheckCircle2, Clock, IndianRupee, MessageSquare, TrendingUp, Wallet } from "lucide-react";
import { api, fmtINR } from "@/lib/api";

const CARDS = [
  { key: "total_bookings", label: "Total Bookings", icon: CalendarRange },
  { key: "active", label: "Active Events", icon: TrendingUp },
  { key: "pending", label: "Pending Payment", icon: Clock },
  { key: "completed", label: "Completed", icon: CheckCircle2 },
  { key: "new_inquiries", label: "New Inquiries", icon: MessageSquare },
  { key: "advance_collected", label: "Advance Collected", icon: Wallet, money: true },
  { key: "booking_value", label: "Booking Value", icon: IndianRupee, money: true },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-display text-3xl text-zinc-900 mb-1">Dashboard</h1>
      <p className="text-zinc-600 text-sm mb-8">Overview of your event operations</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <div key={c.key} className="bg-card border border-pink-200 rounded-xl p-5" data-testid={`stat-${c.key}`}>
            <div className="flex items-center justify-between">
              <span className="text-xs tracking-wide uppercase text-zinc-500">{c.label}</span>
              <c.icon size={18} className="text-gold" />
            </div>
            <div className="text-3xl font-display text-zinc-900 mt-3">
              {stats ? (c.money ? fmtINR(stats[c.key]) : stats[c.key]) : "—"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
